import Backbone from 'backbone'

const ResultModel = Backbone.Model.extend({
    defaults: {
        user: null,
        app_title: null,
        level: null,
        start_timestamp: null,
        end_timestamp: null,
        score: 0,
        total: 0,
        question_log: [],
        fluency_score: 0,
        fluency_total: 0,
        reasoning_score: 0,
        reasoning_total: 0,
        problem_score: 0,
        problem_total: 0,
        star: 0,
        synced: false,
    }
})

export default ResultModel
